import { createComponent } from "../../../../helpers/React";
import styles from "./StudentNameColumn.scss";

export const StudentNameColumn = createComponent({
  tag: "div",
  className: styles.studentNameColumn,
});
